// A client's tasks, in the order the server sent them. The board and the leads screen
// show OPEN work only — "בוצע" takes a task off them — and the board's "בוצעו" view sends
// finished tasks only, newest first, struck through. So a list never mixes the two and
// needs no fold. Nothing here fetches — the server already sent these rows.
import TaskRow from './TaskRow';

// Work still outstanding. Shared because "open" is a judgement several screens make
// about the same rows — the collapsed lead card, the board's fold default, this list
// — and they must never disagree about what still counts as needing doing.
export const openTasks = (tasks) => (tasks || []).filter((t) => t.status !== 'done');

export default function TaskList({
  tasks, emptyText, onEdit, onChanged, editingNoteId, onStartNote, onStopNote,
}) {
  if (!tasks || tasks.length === 0) {
    return <p className="muted small-note">{emptyText}</p>;
  }

  return (
    <div className="group-tasks">
      {tasks.map((t) => (
        <TaskRow
          key={t.id}
          task={t}
          onEdit={onEdit}
          onChanged={onChanged}
          noteEditing={editingNoteId === t.id}
          onStartNote={() => onStartNote(t.id)}
          onStopNote={() => onStopNote(t.id)}
        />
      ))}
    </div>
  );
}
